module.exports = __webpack_public_path__ + "static/media/munich_demonstr.cdd3506b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/munich_demonstr.jpg
// module id = 463
// module chunks = 0